export default [{
    path: '/accounts',
    name: 'accounts',
    component: () =>
        import ('@/views/pages/accounts/AccountsList.vue'),
    meta: {
        pageTitle: 'Accounts',
        breadcrumb: [{
            text: 'Accounts',
            active: true,
            to:'/accounts'
        }, ],
        resource: 'student',
        action: 'read',
    },
},
{
    path: '/accounts/view/:id',
    name: 'accounts-view',
    component: () =>
        import ('@/views/pages/accounts/accounts-view/AccountsView.vue'),
    meta: {
        pageTitle: 'View account',
        breadcrumb: [
        {
            text: 'Accounts',
            to: '/accounts'
        },{
            text: 'View',
            active: true,
        },],
        resource: 'student',
        action: 'read',
    },
},
{
    path: '/accounts/edit/:id',
    name: 'accounts-edit',
    component: () =>
        import ('@/views/pages/accounts/AccountsEdit.vue'),
    meta: {
        pageTitle: 'Edit account',
        breadcrumb: [
        {
            text: 'Accounts',
            to: '/accounts',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'student',
        action: 'read',
    },
},
{
    path: '/accounts/add',
    name: 'accounts-add',
    component: () =>
        import ('@/views/pages/accounts/AccountsAdd.vue'),
    meta: {
        pageTitle: 'Create account',
        breadcrumb: [
        {
            text: 'Accounts',
            to: '/accounts',
        },
        {
            text: 'Add',
            active: true,
        }
        ],
        resource: 'student',
        action: 'read',
    },
}
]
